/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { Fragment } from 'react';

import { Button, Modal } from '@forge/common';
import { useTranslation } from 'react-i18next';

import "./index.scss";

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    content: React.ReactNode;
    footerLeftText?: string;
    footerRightText?: string;
    footerLeftDisabled?: boolean;
    footerRightDisabled?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen, onClose, onConfirm, title, content,
    footerLeftText = 'cancel', footerRightText = 'confirm',
    footerLeftDisabled = false, footerRightDisabled = false
}) => {
    const { t } = useTranslation();

    return (
        <Fragment>
            {isOpen && (
                <Modal
                    backdrop
                    title={title}
                    onBackdropClick={onClose}
                    onModalClose={onClose}
                    className="confirmation-modal"
                >
                   <div className="confirmation-modal-content">{content}</div> 
                    <div className="confirmation-modal-footer">
                        <Button onClick={onClose} variant="secondary" disabled={footerLeftDisabled}>
                            {t(footerLeftText)}
                        </Button>
                        <Button onClick={onConfirm} disabled={footerRightDisabled}>
                            {t(footerRightText)}
                        </Button>
                    </div>
                </Modal>
            )}
        </Fragment>
    );
};

export default ConfirmationModal;
